import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, input, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { BasketApiMap } from 'src/business/basket';
import { BasketReturnModel, Money, OrderModel, OrderReturnModel } from 'src/business/openapi';
import { CommonModule } from 'src/common/common.module';

@Component({
  selector: 'app-ecommerce-summary',
  templateUrl: './ecommerce-summary.component.html',
  styleUrls: ['./ecommerce-summary.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule]
})
export class EcommerceSummaryComponent {

  order = input<OrderModel>();
  summary: Signal<Array<{ text: string, price: Money }>>;

  constructor() {
    let basket$ = toSignal(BasketApiMap.basket$);
    this.summary = computed<Array<{ text: string, price: Money }>>(() => {
      const order = this.order();
      let basket: BasketReturnModel | OrderReturnModel | undefined = basket$()?.basket;
      if (order)
        basket = order;
      if (basket == null)
        return [];
      let summary = [];
      if (basket != null) {
        summary.push({ text: 'total_ex_vat', price: { amount: (basket.total?.amount || 0) - (basket.totalVat?.amount || 0), currency: (basket.total?.currency ?? 'XXX') } });
        // if (basket.totalDiscount.amount > 0)
        //     this.prices.push({ text: 'total_shipping', price: basket.totalDiscount });
        // if (basket.totalDiscount.amount > 0)
        //     this.prices.push({ text: 'total_enviroment', price: basket.totalDiscount });
        if (basket.totalVat != null)
          summary.push({ text: 'total_vat', price: basket.totalVat });
        if ((basket.totalDiscount?.amount ?? 0) > 0)
          if (basket.totalDiscount != null)
            summary.push({ text: 'total_discount', price: basket.totalDiscount });
        // if (basket.totalDiscount.amount > 0)
        //     this.prices.push({ text: 'total_invoice_fee', price: basket.totalDiscount });
        summary.push({ text: 'line', price: { amount: 0, currency: 'XXX' } });
        if (basket.total != null)
          summary.push({ text: 'total_in_vat', price: basket.total });
      }
      return summary;
    });

  }


}
